import { BaseModel } from '../core/abstractions/base.model';

export class ZoomSignatureRequestModel extends BaseModel {
    meetingNumber!: number;
    role = 0;

    constructor(init?: Partial<ZoomSignatureRequestModel>) {
        super();
        Object.assign(this, init);
    }
}
